module.exports = __webpack_public_path__ + "static/media/dws_refresh.0823af38.png";